const generateCSV = (arr) =>
  arr.reduce(
    (acc, cur) => `${acc}${cur.map(encodeURIComponent).join(',')}\r\n`,
    'data:text/csv;charset=utf-8,'
  );

export default generateCSV;
